import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ProductCard, Chip, SectionHeader, Skeleton } from "@/components/kit";
import { Award, TrendingUp, DollarSign, Sparkles } from "lucide-react";

const LISTS = [
  { key: "rating", label: "Top rated this week", icon: Award },
  { key: "reviews", label: "Community favorites", icon: Sparkles },
  { key: "price", label: "Best value", icon: DollarSign },
];

export default function Ratings() {
  const [cats, setCats] = useState([]);
  const [products, setProducts] = useState(null);
  const [cat, setCat] = useState("All");
  const [sort, setSort] = useState("rating");
  const [params] = useSearchParams();
  const q = params.get("q")?.toLowerCase();

  useEffect(() => { api.get("/categories").then((r) => setCats(["All", ...r.data])); }, []);
  useEffect(() => {
    setProducts(null);
    api.get(`/products?sort=${sort}${cat !== "All" ? `&category=${cat}` : ""}`).then((r) => {
      let d = r.data;
      if (q) d = d.filter((p) => p.name.toLowerCase().includes(q) || p.category.toLowerCase().includes(q));
      setProducts(d);
    });
  }, [cat, sort, q]);

  return (
    <div className="mx-auto max-w-6xl px-4 py-8 lg:px-6">
      <SectionHeader overline="Rate & review premium bottles" title="Ratings & rankings" />
      <div className="mb-5 flex flex-wrap gap-2">
        {LISTS.map((l) => (
          <button key={l.key} data-testid={`ratings-sort-${l.key}`} onClick={() => setSort(l.key)}
            className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-sm font-medium ${sort === l.key ? "border-primary bg-primary/10 text-primary" : "border-border text-muted-foreground hover:text-foreground"}`}>
            <l.icon size={14} /> {l.label}
          </button>
        ))}
      </div>
      <div className="scrollbar-thin mb-8 flex gap-2 overflow-x-auto pb-2">
        {cats.map((c) => <div key={c} className="shrink-0"><Chip data-testid={`cat-${c}`} active={cat === c} onClick={() => setCat(c)}>{c}</Chip></div>)}
      </div>
      {q && <p className="mb-4 text-sm text-muted-foreground">Results for “{q}”</p>}
      {!products ? (
        <div className="grid grid-cols-2 gap-6 lg:grid-cols-4">{Array.from({ length: 8 }).map((_, i) => <Skeleton key={i} className="h-80" />)}</div>
      ) : products.length === 0 ? (
        <p className="py-16 text-center text-muted-foreground">No bottles match your filters.</p>
      ) : (
        <div className="grid grid-cols-2 gap-6 lg:grid-cols-4">{products.map((p) => <ProductCard key={p.id} p={p} />)}</div>
      )}
    </div>
  );
}
